// try {
//   module = await import(
//     /* webpackInclude: /\.page\.vue$/ */
//     `@/modules/${name}.page.vue`
//     )
// } catch (error) {
//   if (error.code === 'MODULE_NOT_FOUND') {
//     module = await import(
//       /* webpackInclude: /\.page\.vue$/ */
//       `@/modules/${name}/index.page.vue`
//       )
//   } else {
//     throw error
//   }
// }


import {
  ionAdd,
  ionAddCircle,
  ionAddCircleOutline,
  ionAlbums,
  ionAlbumsOutline,
  ionAlertCircle,
  ionAlertCircleOutline,
  ionAlertOutline,
  ionApps,
  ionArrowBack,
  ionArrowBackCircle,
  ionArrowDown,
  ionArrowForward,
  ionArrowForwardCircle,
  ionArrowForwardOutline,
  ionArrowRedo,
  ionArrowRedoOutline,
  ionArrowUpCircleOutline,
  ionAttachOutline,
  ionBanOutline,
  ionBarChartOutline,
  ionCalculator,
  ionCalculatorOutline,
  ionCalendar,
  ionCalendarNumberOutline,
  ionCalendarOutline,
  ionCallOutline,
  ionCard,
  ionCardOutline,
  ionCaretBack,
  ionCaretBackOutline,
  ionCaretDownOutline,
  ionCaretUpOutline,
  ionCart,
  ionCartOutline,
  ionCash,
  ionCashOutline,
  ionChatboxEllipses,
  ionCheckmarkCircle,
  ionCheckmarkCircleOutline,
  ionCheckmarkDoneOutline,
  ionCheckmarkOutline,
  ionChevronBackCircleOutline,
  ionChevronBackOutline,
  ionChevronDownOutline,
  ionChevronForward,
  ionChevronForwardCircleOutline,
  ionChevronForwardOutline,
  ionChevronUpOutline,
  ionClipboard,
  ionClipboardOutline,
  ionCloseCircle,
  ionCloseCircleOutline,
  ionCloseOutline,
  ionCloudDownloadOutline,
  ionCloudUpload,
  ionCloudUploadOutline,
  ionCogOutline,
  ionColorPalette,
  ionColorPaletteOutline,
  ionCopyOutline,
  ionCreate,
  ionCreateOutline,
  ionDesktopOutline,
  ionDocument,
  ionDocumentAttach,
  ionDocumentOutline,
  ionDocumentsOutline,
  ionDocumentText,
  ionDocumentTextOutline,
  ionDownloadOutline,
  ionEnter,
  ionExit,
  ionEye,
  ionEyeOffOutline,
  ionEyeOutline,
  ionFileTrayFullOutline,
  ionFileTrayStackedOutline,
  ionFilter,
  ionFlameOutline,
  ionFolder,
  ionGiftOutline,
  ionGlasses,
  ionGlassesOutline,
  ionGlobeOutline,
  ionGrid,
  ionGridOutline,
  ionHappy,
  ionHappyOutline,
  ionHelpBuoyOutline,
  ionHelpCircle,
  ionHelpCircleOutline,
  ionHomeOutline,
  ionHourglass,
  ionHourglassOutline,
  ionIdCardOutline,
  ionImageOutline,
  ionImages,
  ionInformationCircle,
  ionInformationCircleOutline,
  ionInformationOutline,
  ionKeyOutline,
  ionLaptopOutline,
  ionLink,
  ionLinkOutline,
  ionList,
  ionListOutline,
  ionLockClosedOutline,
  ionLogoBitcoin,
  ionLogoGoogle,
  ionLogoUsd,
  ionMail,
  ionMailOutline,
  ionMegaphone,
  ionMegaphoneOutline,
  ionMenuOutline,
  ionMoon,
  ionMoonOutline,
  ionNavigateCircle,
  ionNewspaperOutline,
  ionNotifications,
  ionNotificationsCircleOutline,
  ionNotificationsOutline,
  ionOpenOutline,
  ionOptionsOutline,
  ionPaperPlaneOutline,
  ionPencilOutline,
  ionPeople,
  ionPeopleOutline,
  ionPerson,
  ionPersonAddOutline,
  ionPersonCircleOutline,
  ionPersonOutline,
  ionPhonePortrait,
  ionPhonePortraitOutline,
  ionPricetagOutline,
  ionReader,
  ionReaderOutline,
  ionReceiptOutline,
  ionRefreshCircleOutline,
  ionRefreshOutline,
  ionReloadCircleOutline,
  ionReloadOutline,
  ionRemove,
  ionRemoveCircleOutline,
  ionReorderFourOutline,
  ionRibbon,
  ionRocketOutline,
  ionRoseOutline,
  ionSaveOutline,
  ionSearchOutline,
  ionSettingsOutline,
  ionShareOutline,
  ionShareSocial,
  ionShieldCheckmarkOutline,
  ionSparkles,
  ionSparklesOutline,
  ionStar,
  ionStatsChartOutline,
  ionStorefront,
  ionSunny,
  ionSunnyOutline,
  ionSwapHorizontalOutline,
  ionSyncOutline,
  ionText,
  ionTextOutline,
  ionTime,
  ionTimeOutline,
  ionTimer,
  ionTimerOutline,
  ionTrash,
  ionTrashBinOutline,
  ionTrashOutline,
  ionWalletOutline,
  ionWarning
} from '@quasar/extras/ionicons-v5'
import { BootFileParams } from '@niknevis/vue-modules/types'
import { ionAscending, ionCampaign, ionDescending } from '../constants/custom-icons'

const customWallet = 'M95.5 104h320a87.73 87.73 0 0111.18.71 66 66 0 00-77.51-55.56L86 94.08h-.3a66 66 0 00-41.07 '
  + '26.13A87.57 87.57 0 0195.5 104zM415.5 128h-320a64.07 64.07 0 00-64 64v192a64.07 64.07 0 0064 64h320a64.07 '
  + '64.07 0 0064-64V192a64.07 64.07 0 00-64-64zM368 320a32 32 0 1132-32 32 32 0 01-32 32z&&M32 259.5V160c0-21.67 '
  + '12-58 53.65-65.87C121 87.5 156 87.5 156 87.5s23 16 4 16-18.5 24.5 0 24.5 0 23.5 0 23.5L85.5 236z|0 0 512 512'

const iconMap = {
  'open-outline': ionOpenOutline,
  'key-outline': ionKeyOutline,
  'arrow-up-circle-outline': ionArrowUpCircleOutline,
  info: ionInformationCircleOutline,
  check: ionCheckmarkCircleOutline,
  alert: ionAlertCircleOutline,
  'alert-fill': ionAlertCircle,
  menu: ionMenuOutline,
  'add-circle': ionAddCircle,
  apps: ionApps,
  campaign: ionCampaign,
  'chevron-forward': ionChevronForward,
  'wallet-outline': ionWalletOutline,
  wallet: customWallet,
  calculator: ionCalculator,
  person: ionPersonOutline,
  support: ionHelpBuoyOutline,
  notifications: ionNotifications,
  'arrow-forward': ionArrowForward,
  'caret-down': ionCaretDownOutline,
  'caret-up-outline': ionCaretUpOutline,
  filter: ionFilter,
  'descending-filter': ionDescending,
  'ascending-filter': ionAscending,
  grid: ionGrid,
  list: ionList,
  'time-outline': ionTimeOutline,
  add: ionAdd,
  trash: ionTrash,
  'cart-outline': ionCartOutline,
  'remove-outline': ionRemove,
  star: ionStar,
  'arrow-forward-outline': ionArrowForwardOutline,
  'chevron-up-outline': ionChevronUpOutline,
  'chevron-down-outline': ionChevronDownOutline,
  'share-social': ionShareSocial,
  'checkmark-circle': ionCheckmarkCircle,
  'close-outline': ionCloseOutline,
  'close-circle': ionCloseCircle,
  'close-circle-outline': ionCloseCircleOutline,
  link: ionLink,
  'reader-outline': ionReaderOutline,
  'reader': ionReader,
  'help-circle': ionHelpCircle,
  'pencil-outline': ionPencilOutline,
  'information-circle-outline': ionInformationCircleOutline,
  'information-circle': ionInformationCircle,
  'information-outline': ionInformationOutline,
  'card-outline': ionCardOutline,
  'store-front': ionStorefront,
  card: ionCard,
  'cloud-upload-outline': ionCloudUploadOutline,
  'cloud-upload': ionCloudUpload,
  'receipt-outline': ionReceiptOutline,
  'download-outline': ionDownloadOutline,
  eye: ionEye,
  'eye-outline': ionEyeOutline,
  'eye-off-outline': ionEyeOffOutline,
  'list-outline': ionListOutline,
  'hourglass-outline': ionHourglassOutline,
  'timer': ionTimer,
  'hourglass': ionHourglass,
  'checkmark-outline': ionCheckmarkOutline,
  'calendar-outline': ionCalendarOutline,
  'calendar': ionCalendar,
  'laptop-outline': ionLaptopOutline,
  'save-outline': ionSaveOutline,
  'document': ionDocument,
  'warning': ionWarning,
  'options-outline': ionOptionsOutline,
  'search-outline': ionSearchOutline,
  'copy-outline': ionCopyOutline,
  'id-card-outline': ionIdCardOutline,
  'megaphone-outline': ionMegaphoneOutline,
  'settings-outline': ionSettingsOutline,
  'attach-outline': ionAttachOutline,
  'reorder-four-outline': ionReorderFourOutline,
  'clipboard-outline': ionClipboardOutline,
  'clipboard': ionClipboard,
  'alert-circle': ionAlertCircle,
  'newspaper-outline': ionNewspaperOutline,
  'enter': ionEnter,
  'arrow-down': ionArrowDown,
  'exit': ionExit,
  'reload-circle': ionReloadCircleOutline,
  reload: ionReloadOutline,
  'arrow-forward-circle': ionArrowForwardCircle,
  cart: ionCart,
  folder: ionFolder,
  time: ionTime,
  'cloud-download-outline': ionCloudDownloadOutline,
  'arrow-back-circle': ionArrowBackCircle,
  'help-circle-outline': ionHelpCircleOutline,
  'timer-outline': ionTimerOutline,
  'trash-bin-outline': ionTrashBinOutline,
  'arrow-back': ionArrowBack,
  'albums-outline': ionAlbumsOutline,
  'albums': ionAlbums,
  'image-outline': ionImageOutline,
  'paper-plane-outline': ionPaperPlaneOutline,
  'create-outline': ionCreateOutline,
  'create': ionCreate,
  'pricetag-outline': ionPricetagOutline,
  'desktop-outline': ionDesktopOutline,
  'mail-outline': ionMailOutline,
  'call-outline': ionCallOutline,
  'stats-chart-outline': ionStatsChartOutline,
  'lock-closed-outline': ionLockClosedOutline,
  'logo-google': ionLogoGoogle,
  'home-outline': ionHomeOutline,
  'phone-portrait-outline': ionPhonePortraitOutline,
  'refresh-outline': ionRefreshOutline,
  'notifications-outline': ionNotificationsOutline,
  'chatbox-ellipses': ionChatboxEllipses,
  'refresh-circle-outline': ionRefreshCircleOutline,
  'checkmark-circle-outline': ionCheckmarkCircleOutline,
  'cash-outline': ionCashOutline,
  'cash': ionCash,
  'logo-bitcoin': ionLogoBitcoin,
  'logo-usd': ionLogoUsd,
  'chevron-back-outline': ionChevronBackOutline,
  'chevron-forward-outline': ionChevronForwardOutline,
  'file-tray-full-outline': ionFileTrayFullOutline,
  'chevron-forward-circle-outline': ionChevronForwardCircleOutline,
  'chevron-back-circle-outline': ionChevronBackCircleOutline,
  'add-circle-outline': ionAddCircleOutline,
  'swap-horizontal-outline': ionSwapHorizontalOutline,
  'bar-chart-outline': ionBarChartOutline,
  'link-outline': ionLinkOutline,
  'calculator-outline': ionCalculatorOutline,
  'remove-circle-outline': ionRemoveCircleOutline,
  'images-outline': ionImages,
  'sync-outline': ionSyncOutline,
  'share-outline': ionShareOutline,
  'globe-outline': ionGlobeOutline,
  'help-buoy-outline': ionHelpBuoyOutline,
  'people-outline': ionPeopleOutline,
  'person-add-outline': ionPersonAddOutline,
  'person-circle-outline': ionPersonCircleOutline,
  'person-fill': ionPerson,
  'phone-portrait': ionPhonePortrait,
  'mail': ionMail,
  'ribbon': ionRibbon,
  'navigate-circle': ionNavigateCircle,
  'people': ionPeople,
  'text': ionText,
  'gift-outline': ionGiftOutline,
  'arrow-redo': ionArrowRedo,
  'arrow-redo-outline': ionArrowRedoOutline,
  'calendar-number-outline': ionCalendarNumberOutline,
  'text-outline': ionTextOutline,
  'caret-back-outline': ionCaretBackOutline,
  'pricetags-outline': ionPricetagOutline,
  'shield-checkmark-outline': ionShieldCheckmarkOutline,
  'ban-outline': ionBanOutline,
  'glasses-outline': ionGlassesOutline,
  'glasses': ionGlasses,
  'checkmark-done-outline': ionCheckmarkDoneOutline,
  'trash-outline': ionTrashOutline,
  'cog-outline': ionCogOutline,
  'document-outline': ionDocumentOutline,
  'rocket-outline': ionRocketOutline,
  'megaphone': ionMegaphone,
  'happy-outline': ionHappyOutline,
  'happy': ionHappy,
  'moon': ionMoon,
  'moon-outline': ionMoonOutline,
  'sunny': ionSunny,
  'sunny-outline': ionSunnyOutline,
  'caret-back': ionCaretBack,
  'document-text-outline': ionDocumentTextOutline,
  'document-text': ionDocumentText,
  'notifications-circle-outline': ionNotificationsCircleOutline,
  'color-palette': ionColorPalette,
  'color-palette-outline': ionColorPaletteOutline,
  'document-attach': ionDocumentAttach,
  'documents-outline': ionDocumentsOutline,
  'file-tray-stacked-outline': ionFileTrayStackedOutline,
  'flame-outline': ionFlameOutline,
  'rose-outline': ionRoseOutline,
  'alert-outline': ionAlertOutline,
  'grid-outline' : ionGridOutline,
  'sparkles': ionSparkles,
  'sparkles-outline': ionSparklesOutline
}

export default function({ Vue }: BootFileParams) {
  Vue.prototype.$q.iconMapFn = iconName => {
    if (iconName.startsWith('ion ')) {
      const name = iconName.substring(4)

      const icon = iconMap[name]

      if (icon !== void 0) {
        return { icon }
      }
    }
  }
}
